import React from 'react';
import Conditional from '../../common/conditional';

import classNames from './style.module.scss';

interface AuditTrailItemProps {
	label: string;
	value?: string;
	signature?: string;
}

const AuditTrailItem: React.FC<AuditTrailItemProps> = (props) => {
	return (
		<div className={classNames.auditTrailItemPair}>
			<div className={classNames.auditTrailItemPairLabel}>{props.label}:</div>

			<Conditional isVisible={!!props.value}>
				<div className={classNames.auditTrailItemPairValue}>
					{props.value || 'N/A'}
				</div>
			</Conditional>

			<Conditional isVisible={!!props.signature}>
				<div className={classNames.auditTrailItemPairValue}>
					<img
						className={classNames.auditTrailItemPairImage}
						src={props.signature}
						alt="Reviewer Signature"
					/>
				</div>
			</Conditional>
		</div>
	);
};

export default AuditTrailItem;
